import { Link } from "react-router-dom";
import ClientLogo from "@/assets/icons/ClientLogo.svg";
import { TResponseOrderDetails } from "@/types/projectType";
import { formatDate } from "@/utils/formateData";
import { TCreatorProjectResponseType } from "../../Projects";
import { DefaultCompanyLogo } from "@/constant";

type TableRowProps = {
  item: TCreatorProjectResponseType;
  index: number;
};

const TableRow = ({ index, item }: TableRowProps) => {
  const order = item?.order_id;
  const quantity = item?.quantity
  const orderStatus = order?.orderStatus?.isPending ? (
    <p className="bg-[#DFEAF4] text-[#003471] text-xs leading-[18px] tracking-[-3%] font-medium border-[#DFEAF4] border rounded-[32px] px-2 py-[2px] inline-block">
      Pending
    </p>
  ) : order?.orderStatus?.isProgress ? (
    <p className="bg-[#FBF1DA] text-[#714B00] text-xs leading-[18px] tracking-[-3%] font-medium border-[#714B0029] border rounded-[32px] px-2 py-[2px] inline-block">
      In Progress
    </p>
  ) : order?.orderStatus?.isCompleted ? (
    <p className="bg-[#E9F5EF] text-[#1D7100] text-xs leading-[18px] tracking-[-3%] font-medium border-[#1D71002E] border rounded-[32px] px-2 py-[2px] inline-block">
      Completed
    </p>
  ) : (
    "Unknown"
  );
  const deadline = formatDate(order?.deadline);


  
  return (
    <tr
      key={index}
      className="border-b-[1.5px] border-[#D0D5DD] h-[66px] last:border-0 py-6"
    >
      <td className=" px-3">
        <span className="text-[rgb(29,41,57)] truncate max-w-[200px] font-medium text-sm block mb-1">
          {order?.projectName || `Project - ${index + 1}`}
        </span>
        <span className="text-xs leading-[18px] text-[#667085] tracking-[-1.5%]">
         {formatDate(order?.createdOn)}
        </span>
      </td>
      <td className="h-[66px] px-3 whitespace-nowrap text-[#1D2939] font-medium text-sm leading-[22px] tracking-[-1%] flex gap-1 items-center">
        <div className="h-[32px] w-[32px]  rounded-full flex justify-center items-center overflow-hidden">
          <img
            className="object-cover  origin-center object-center"
            src={
              order?.clientId?.logo ||
              DefaultCompanyLogo
            }
            alt=""
          />
        </div>
        <p>{order?.clientId?.businessName}</p>
      </td>
      <td className="px-3">
        <p className="text-[#1D2939]  whitespace-nowrap font-medium text-sm leading-[22px] tracking-[-1%] flex justify-start pl-2">
          {quantity}{" "}
          {quantity > 1 ? "Videos" : "Video"}
        </p>
      </td>
      <td className="px-3  whitespace-nowrap text-[#1D2939] font-medium text-sm leading-[22px] tracking-[-1%] ">
        {deadline}
      </td>

      <td className=" px-3 text-[#1D2939] font-medium text-sm">
        {orderStatus}
      </td>
      <td className="h-full px-3 font-medium text-xs leading-[18px]">
        <div className="flex justify-between items-center">
          <Link
            to={`/projects/project-management/${item?.order_id?._id}?videoId=1&p_id=${item?._id}`}
          >
            <p className="text-[#002B7F] whitespace-nowrap  cursor-pointer text-center">
              Complete Actions
            </p>
          </Link>

          <Link
            to={`/orders/order-management/${item?.order_id?._id}?videoId=1&p_id=${item?._id}`}
          >
            <p className="text-[#ED5E00] whitespace-nowrap  text-xs leading-[18px] cursor-pointer px-3">
              View Details
            </p>
          </Link>
        </div>
      </td>
    </tr>
  );
};

export default TableRow;
